import React from "react";
import { BrandWrapper, BrandLogo, Bubble1, Bubble2, Bubble3 } from "./styled";
import appLogo from "./img/app-logo@2x.png";
const AppBrand = props => {
  return (
    <BrandWrapper {...props}>
      <Bubble1 />
      <Bubble2 />
      <Bubble3 />
      <BrandLogo src={appLogo}></BrandLogo>
    </BrandWrapper>
  );
};
export default AppBrand;
